<template>
  <div>
    <proyecto-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :data-edit="dataEdit"
      :order="order"
      :select-institucion="dataInstitucion"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <b-card-header>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-card-title>Dependencias de la Institución {{ dataInstitucion.nombre }}</b-card-title>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="query"
              class="d-inline-block mr-1"
              placeholder="Buscar..."
            />
            <b-button
              variant="primary"
              @click="openForm('new')"
            >
              <span class="text-nowrap">Nuevo</span>
            </b-button>
          </div>
        </b-col>
      </b-card-header>
      <b-card-body>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="itemsProject"
          responsive
          :fields="fields"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No se encontraron registros"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">Cargando...</strong>
            </div>
          </template>
          <template #cell(nombre)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.logo"
                />
              </template>
              <b-link
                class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.nombre }}
              </b-link>
              <small class="text-muted">ABREVIATURA:{{ data.item.abreviatura }}</small>
            </b-media>
          </template>
          <template #cell(estado)="data">
            <b-badge
              v-if="data.item.estado == true"
              pill
              variant="light-success"
              class="text-capitalize"
            >
              Activo
            </b-badge>

            <b-badge
              v-if="data.item.estado == false"
              pill
              variant="light-danger"
              class="text-capitalize"
            >
              Inactivo
            </b-badge>
          </template>
          <!-- Column: Actions -->
          <template #cell(acciones)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item @click="getEdit(data)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Editar</span>
              </b-dropdown-item>

              <b-dropdown-item @click="getDelete(data)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Eliminar</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="page"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BBadge, BDropdown, BDropdownItem, BPagination, BSpinner, BCardHeader, BCardTitle, BCardBody, BLink, BMedia, BAvatar,
} from 'bootstrap-vue'
import store from '@/store'
import moment from 'moment'
import ProyectoForm from './ProyectoForm.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BAvatar,
    BMedia,
    BLink,
    ProyectoForm,
  },
  props: {
    dataInstitucion: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoadingImg: true,
    isBusy: false,
    isAddNewSidebarActive: false,
    isOpenEditPassword: false,
    dataEdit: {},
    formType: '',
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    totalPage: 0,
    from: 0,
    to: 0,
    of: 0,
    pageOptions: [10, 20, 50],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    itemsProject: [],
    query: '',
    order: 1,
    items: [],
    fields: [
      { key: 'idProyecto', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'nombre', label: 'Dependencia', sortable: true },
      { key: 'institucion.nombre', label: 'Institución', sortable: true },
      // { key: 'nombre_responsable', sortable: true },
      { key: 'acciones' },
    ],
  }),
  watch: {
    dataInstitucion: {
      handler() {
        this.listarRegistros()
      },
    },
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    listarRegistros() {
      this.isBusy = true
      if (this.dataInstitucion.idInstitucion !== undefined) {
        store
          .dispatch('gsencuesta/PROYECTO_FIND_ALL', {
            idInstitucion: this.dataInstitucion.idInstitucion,
            limit: this.perPage,
            query: this.query,
            page: this.page,
            sortBy: 'idProyecto%7CASC',
          })
          .then(response => {
            // this.items = response.items
            this.itemsProject = []
            response.items.forEach((dat, index) => {
              const ca = moment(dat.createdAt).format('DD/MM/YYYY')
              this.itemsProject.push({
                index,
                nombre: dat.nombre,
                idProyecto: dat.idProyecto,
                institucion: dat.institucion,
                longitud: dat.longitud,
                latitud: dat.latitud,
                nombreResponsable: dat.nombreResponsable,
                createdAt: ca,
                abreviatura: dat.abreviatura,
                logo: `https://apimesa.regionsanmartin.gob.pe/gsencuesta/api/v1/recurso/proyecto/${dat.idProyecto}`, // OPTIMIZAR
                estado: dat.estado,
              })
            })
            this.totalRows = response.totalRows
            this.totalItems = response.totalItems
            this.totalPage = response.totalPage
            this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
            this.to = this.perPage * (this.page - 1) + this.totalRows
            this.of = this.totalItems
            this.isBusy = false
            // console.log(this.order)
          })
          .catch(error => {
            this.showError(error)
            this.isBusy = false
          })
      }
    },
    openForm(type) {
      this.formType = type
      this.isAddNewSidebarActive = true
    },
    getEdit(data) {
      this.formType = 'edit'
      this.isAddNewSidebarActive = true
      this.dataEdit = data.item
    },
    getDelete(data) {
      this.$swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/PROYECTO_DELETE', {
              id: data.item.idProyecto,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    async getLogo(idProyecto) {
      this.isLoadingImg = true
      await store
        .dispatch('gsencuesta/PROYECTO_FIND_LOGO', {
          idProyecto,
        })
        .then(response => {
          const dat = `data:image/png;base64,${Buffer.from(response, 'binary').toString('base64')}`
          // console.log(dat)
          this.isLoadingImg = false
          return dat
        })
        .catch(() => {
        })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    getDateFmt(date) {
      return moment(String(date)).format('DD/MM/YYYY hh:mm a')
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
